import React from 'react';

import ArrowLeftRight from '@ast/magma/components/icon/icons/ArrowLeftRight';
import Bank from '@ast/magma/components/icon/icons/Bank';
import Cards from '@ast/magma/components/icon/icons/Cards';
import Chart from '@ast/magma/components/icon/icons/Chart';
import CheckDelete from '@ast/magma/components/icon/icons/CheckDelete';
import Doc from '@ast/magma/components/icon/icons/Doc';
import Globe from '@ast/magma/components/icon/icons/Globe';
import MoneyAction from '@ast/magma/components/icon/icons/MoneyAction';
import Receipt from '@ast/magma/components/icon/icons/Receipt';
import Transfer from '@ast/magma/components/icon/icons/Transfer';
import TurnForward from '@ast/magma/components/icon/icons/TurnForward';
import UsdCircle from '@ast/magma/components/icon/icons/UsdCircle';

import { TransfersFeatures } from '@app/queryTyping';

import { t } from '@make-transfer/hooks/common';
import {
  Channel,
  ChannelId,
} from '@make-transfer/types/common';

export const getChannelsList = (availableFeatures: TransfersFeatures): Channel[] => [
  {
    icon: <TurnForward />,
    id: ChannelId.Internal,
    dataStableName: 'internalTransfer',
    label: t(
      'channels.label.internal|Label for internal transfer menuitem',
      'At {{fIShortName}}',
      { fIShortName: availableFeatures.fiShortName },
    ),
  },
  {
    icon: <Bank />,
    id: ChannelId.External,
    dataStableName: 'externalTransfer',
    label: t(
      'channels.label.external|Label for external transfer menuitem',
      'At other banks',
    ),
    isEnabled: availableFeatures.isExternalAccountsAvailable,
  },
  {
    icon: <Transfer />,
    id: ChannelId.ACH,
    dataStableName: 'achTransfer',
    label: t(
      'channels.label.ach|Label for ach transfer menuitem',
      'Business ACH Transfer',
    ),
    isEnabled: availableFeatures.isBusinessTransfersAvailable,
  },
  {
    icon: <Cards />,
    id: ChannelId.PayByCard,
    dataStableName: 'payByCard',
    label: t(
      'channels.label.paybycard|Label for pay by card menuitem',
      'Pay by card',
    ),
    isEnabled: availableFeatures.isPayByCardAvailable,
  },
  {
    icon: <Doc />,
    id: ChannelId.Invoices,
    dataStableName: 'sendInvoice',
    label: t(
      'channels.label.send-invoice|Label for send invoice menuitem',
      'Send invoice',
    ),
    isEnabled: availableFeatures.isOneOffInvoiceAvailable,
  },
  {
    icon: <Globe />,
    id: ChannelId.Wire,
    dataStableName: 'wire',
    label: t(
      'channels.label.wire|Label for wire menuitem',
      'Wire money',
    ),
    isEnabled: availableFeatures.isWireTransferAvailable,
  },
  {
    icon: <Chart />,
    id: ChannelId.Investment,
    dataStableName: 'investmentTransfer',
    label: t(
      'channels.label.investments|Label for investment transfer menuitem',
      'Investments',
    ),
    isEnabled: availableFeatures.isInvestmentAvailable,
  },
  {
    icon: <ArrowLeftRight />,
    id: ChannelId.P2P,
    dataStableName: 'p2pTransfer',
    label: t(
      'channels.label.p2p|Label for p2p transfer menuitem',
      'Send or request money',
    ),
    // Not used, but let stay in list.
    isEnabled: false,
  },
  {
    icon: <ArrowLeftRight />,
    id: ChannelId.M2M,
    dataStableName: 'm2mTransfer',
    label: t(
      'channels.label.m2m|Label for m2m transfer menuitem',
      'To another member',
    ),
    isEnabled: availableFeatures.isMemberToMemberAvailable,
  },
  {
    icon: <MoneyAction />,
    id: ChannelId.BillPay,
    dataStableName: 'billpayTransfer',
    label: t(
      'channels.label.billpay|Label for billpay transfer menuitem',
      'Bill pay',
    ),
    isEnabled: false,
  },
  {
    icon: <Receipt />,
    id: ChannelId.CheckWithdrawal,
    dataStableName: 'withdrawalTransfer',
    label: t(
      'channels.label.withdrawal|Label for withdrawal transfer menuitem',
      'Check withdrawal',
    ),
    isEnabled: false,
    // Not supported now
    // isEnabled: availableFeatures.isCheckWithdrawalAvailable,
  },
  {
    icon: <CheckDelete />,
    id: ChannelId.StopCheck,
    dataStableName: 'stopCheckPayment',
    label: t(
      'channels.label.stop-check|Label for stop check payment menuitem',
      'Stop check payment',
    ),
    isEnabled: availableFeatures.isStopCheckPaymentAvailable,
  },
  {
    icon: <UsdCircle />,
    id: ChannelId.Skip,
    dataStableName: 'skipTransfer',
    label: t(
      'channels.label.skip|Label for skip transfer menuitem',
      'Skip a payment',
    ),
    isEnabled: availableFeatures.isSkipPaymentAvailable,
  },
];
